<template>
  <div class="end">
    <div class="question">{{ $t('promotion_new.end_date') }}</div>
    <datetime type="datetime" v-model="promotion.endAt" :use12-hour="true"/>
  </div>
</template>

<script>
export default {
  name: "PromotionEnd",

  props: {
    promotion: Object
  }
}
</script>